import { useQuery } from "@tanstack/react-query";

import { makeApiRequest } from "../../utils";
import { COMMUNITY_REVIEWS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchCommunityReviews = ({
  page = 1,
  pageSize = 20,
  status,
  sortField,
  sortOrder,
  brandName = ""
}) => {
  const searchParams = new URLSearchParams({
    page,
    pageSize,
    brandName,
    status: status === "All" ? "" : status,
    sortField,
    sortOrder
  }).toString();

  return useQuery({
    queryKey: [COMMUNITY_REVIEWS_QUERY_KEY],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: `/api/communityReviews?${searchParams}`,
        method: "GET"
      });
    },
    keepPreviousData: true
  });
};
